import { IUser } from 'app/shared/model/user.model';
import { IInterview } from 'app/shared/model/interview.model';
import { InterviewProcess } from 'app/shared/model/enumerations/interview-process.model';

export interface IInterviewParticipant {
  id?: number;
  processStatus?: InterviewProcess | null;
  dailyCoGuestLink?: string | null;
  user?: IUser | null;
  interview?: IInterview | null;
}

export const defaultValue: Readonly<IInterviewParticipant> = {};
